export const validateEAN13 = (codigoBarras) => {
    if (!/^\d{13}$/.test(codigoBarras)) {
        return false;
    }

    const digitos = codigoBarras.split('').map(Number);

    let sumaImpar = 0;
    let sumaPar = 0;

    for (let i = 0; i < 12; i++) {
        if (i % 2 === 0) {
            sumaImpar += digitos[i];
        } else {
            sumaPar += digitos[i];
        }
    }

    const total = sumaImpar + sumaPar * 3;
    const digitoVerificador = (10 - (total % 10)) % 10;

    return digitoVerificador === digitos[12];
}
